import { gql } from '@apollo/client';

import { Organization } from '../types/organizations';

export type GetUserOrganizations = {
  getUserOrganizations: Organization[];
};

export type GetUserOrganizationsVariables = Record<string, never>;

const GET_USER_ORGANIZATIONS = gql`
  query getUserOrganizations {
    getUserOrganizations {
      id
      name
      display_name
      branding {
        logo_url
      }
    }
  }
`;

export default GET_USER_ORGANIZATIONS;
